document.addEventListener("DOMContentLoaded", function () {
  var mainImage = document.querySelector("[data-main-product-image]");
  var thumbs = document.querySelectorAll("[data-gallery-thumb]");

  thumbs.forEach(function (thumb) {
    function changeImage() {
      var newSrc = thumb.getAttribute("data-full-image");
      var newAlt = thumb.getAttribute("data-alt-text") || "";

      if (mainImage && newSrc) {
        mainImage.src = newSrc;
        mainImage.alt = newAlt;
      }

      thumbs.forEach(function (item) {
        item.classList.remove("active");
      });

      thumb.classList.add("active");
    }

    thumb.addEventListener("click", changeImage);
    thumb.addEventListener("mouseenter", changeImage);
  });
});
